"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalutationMappings = void 0;
const SalutationTypes_1 = __importDefault(require("../../common/js/enums/SalutationTypes"));
exports.SalutationMappings = new Map([
    ['fr.', SalutationTypes_1.default.ms],
    ['hr.', SalutationTypes_1.default.mr],
    ['mr', SalutationTypes_1.default.mr],
    ['mr.', SalutationTypes_1.default.mr],
    ['mrs', SalutationTypes_1.default.ms],
    ['mrs.', SalutationTypes_1.default.ms],
    ['ms', SalutationTypes_1.default.ms],
    ['ms.', SalutationTypes_1.default.ms],
]);
